module.exports = __webpack_public_path__ + "img/28_9.8c7712b3.png";